module.exports = __webpack_public_path__ + "img/modifications--without_mattras.858b7041.jpg";